(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-banner')) {
    customElements.define(
      'hero-banner',
      class HeroBanner extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          if (!this.track) return;

          this.slides = Array.from(this.track.querySelectorAll('[data-slide]'));
          this.refs = Array.from(this.querySelectorAll('[data-ref]'));
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.prevBtn = this.querySelector('[data-prev]');
          this.nextBtn = this.querySelector('[data-next]');
          this.count = this.slides.length;
          this.loop = this.count > 1;
          this.index = 0; // logical slide (0..count-1)
          this.pos = 0; // position in the track (clones included)
          this.drag = null;
          this.timer = null;
          this.fallback = null;
          this.animating = false;
          this.hoverPaused = false;
          this.editorPaused = false;
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.delay = (parseInt(this.dataset.delay, 10) || 5) * 1000;
          this.autoplay = this.dataset.autoplay === 'true' && this.loop && !this.reduced;

          // Per-slide text & button position is driven by this attribute (see the generated CSS)
          this.dataset.active = '0';

          // Infinite loop: clone the last slide before the first and the first after the last
          if (this.loop) {
            this.track.insertBefore(this.makeClone(this.slides[this.count - 1]), this.slides[0]);
            this.track.appendChild(this.makeClone(this.slides[0]));
            this.jump(1);
          }
          this.all = Array.from(this.track.children);

          this.onVisibility = () => this.schedule();
          document.addEventListener('visibilitychange', this.onVisibility);

          this.track.addEventListener('transitionend', (e) => {
            if (e.target === this.track && e.propertyName === 'transform') this.settle();
          });

          if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
          if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());
          this.dots.forEach((dot, n) => dot.addEventListener('click', () => this.goTo(n)));

          // Swipe / drag on the moving backgrounds
          this.track.addEventListener('pointerdown', (e) => this.onDown(e));
          this.track.addEventListener('pointermove', (e) => this.onMove(e));
          this.track.addEventListener('pointerup', (e) => this.onUp(e));
          this.track.addEventListener('pointercancel', (e) => this.onUp(e));

          // Pause autoplay on hover / focus
          this.addEventListener('mouseenter', () => {
            this.hoverPaused = true;
            this.clear();
          });
          this.addEventListener('mouseleave', () => {
            this.hoverPaused = false;
            this.schedule();
          });
          this.addEventListener('focusin', () => {
            this.hoverPaused = true;
            this.clear();
          });
          this.addEventListener('focusout', () => {
            this.hoverPaused = false;
            this.schedule();
          });

          // Theme editor: show the slide of the selected block
          this.addEventListener('shopify:block:select', (event) => {
            const n = this.slides.indexOf(event.target.closest('[data-slide]'));
            this.editorPaused = true;
            this.clear();
            if (n > -1) {
              this.animating = false;
              this.goTo(n);
            }
          });
          this.addEventListener('shopify:block:deselect', () => {
            this.editorPaused = false;
            this.schedule();
          });

          this.syncVideos();
          this.schedule();
        }

        disconnectedCallback() {
          this.clear();
          clearTimeout(this.fallback);
          document.removeEventListener('visibilitychange', this.onVisibility);
        }

        makeClone(slide) {
          const clone = slide.cloneNode(true);
          ['data-slide', 'data-shopify-editor-block', 'role', 'aria-label'].forEach((a) => clone.removeAttribute(a));
          clone.setAttribute('data-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
          clone.querySelectorAll('img').forEach((img) => {
            img.loading = 'eager';
            img.removeAttribute('fetchpriority');
          });
          clone.querySelectorAll('iframe').forEach((frame) => (frame.loading = 'eager'));
          return clone;
        }

        // Place the track at a position instantly (no animation)
        jump(pos) {
          this.pos = pos;
          this.track.classList.add('is-jumping');
          this.track.style.setProperty('--i', pos);
          this.track.style.setProperty('--drag', '0px');
          void this.track.offsetWidth;
          this.track.classList.remove('is-jumping');
        }

        // Called when a slide animation ends: silently swap clones for the real slides
        settle() {
          clearTimeout(this.fallback);
          if (this.loop) {
            if (this.pos === 0) this.jump(this.count);
            else if (this.pos === this.count + 1) this.jump(1);
          }
          this.animating = false;
          this.syncVideos();
          this.schedule();
        }

        move(index, pos, dir) {
          if (this.animating || !this.loop) return;
          this.animating = true;
          const prev = this.index;
          this.index = index;
          this.pos = pos;

          // Switch to the text & button position of the new slide
          this.dataset.active = String(index);

          this.track.style.setProperty('--i', pos);
          this.updateText(prev, dir);
          this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === index ? 'true' : 'false'));
          this.syncVideos();
          this.clear();

          clearTimeout(this.fallback);
          this.fallback = setTimeout(() => this.settle(), this.reduced ? 60 : 1100);
        }

        next() {
          this.move((this.index + 1) % this.count, this.pos + 1, 1);
        }

        prev() {
          this.move((this.index - 1 + this.count) % this.count, this.pos - 1, -1);
        }

        goTo(n) {
          if (n === this.index) return;
          this.move(n, n + 1, n > this.index ? 1 : -1);
        }

        // Animated text swap: outgoing leaves in the direction of travel, incoming arrives from the opposite side
        updateText(prev, dir) {
          const idx = this.index;

          // Park the incoming text on the correct side (instantly, while invisible)
          this.refs.forEach((el) => {
            if (Number(el.dataset.ref) !== idx) return;
            el.style.transition = 'none';
            el.classList.remove('is-active');
            el.classList.toggle('is-before', dir < 0);
          });
          void this.track.offsetWidth;

          this.refs.forEach((el) => {
            const r = Number(el.dataset.ref);
            const active = r === idx;
            el.style.transition = '';
            el.classList.toggle('is-active', active);
            if (!active && r === prev) el.classList.toggle('is-before', dir > 0);
            el.setAttribute('aria-hidden', active ? 'false' : 'true');
            if (el.tagName === 'A') el.tabIndex = active ? 0 : -1;
          });
        }

        syncVideos() {
          if (!this.all) return;
          this.all.forEach((slide, p) => {
            slide.querySelectorAll('video').forEach((video) => {
              video.muted = true;
              video.playsInline = true;
              if (p === this.pos) {
                const played = video.play();
                if (played && played.catch) played.catch(() => {});
              } else {
                video.pause();
              }
            });
          });
        }

        clear() {
          clearTimeout(this.timer);
        }

        schedule() {
          this.clear();
          if (!this.autoplay || this.hoverPaused || this.editorPaused || document.hidden) return;
          this.timer = setTimeout(() => this.next(), this.delay);
        }

        onDown(e) {
          if (!this.loop || this.animating) return;
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          this.drag = { id: e.pointerId, x: e.clientX, raw: 0, moved: false };
        }

        onMove(e) {
          const d = this.drag;
          if (!d || e.pointerId !== d.id) return;

          const dx = e.clientX - d.x;
          if (!d.moved) {
            if (Math.abs(dx) < 6) return;
            d.moved = true;
            try {
              this.track.setPointerCapture(d.id);
            } catch (err) {}
            this.track.classList.add('is-dragging');
            this.clear();
          }

          d.raw = dx;
          this.track.style.setProperty('--drag', dx + 'px');
        }

        onUp(e) {
          const d = this.drag;
          this.drag = null;
          if (!d || !d.moved) return;

          try {
            this.track.releasePointerCapture(d.id);
          } catch (err) {}

          this.track.classList.remove('is-dragging');
          this.track.style.setProperty('--drag', '0px');

          const threshold = Math.min(90, this.track.clientWidth * 0.15);
          if (d.raw < -threshold) this.next();
          else if (d.raw > threshold) this.prev();
          else this.schedule();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot-viewer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hotspot-viewer')) {
    customElements.define(
      'hotspot-viewer',
      class HotspotViewer extends HTMLElement {
        connectedCallback() {
          this.mediaEl = this.querySelector('[data-media]');
          this.spots = Array.from(this.querySelectorAll('[data-spot]'));
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.track = this.querySelector('[data-track]');
          this.viewport = this.querySelector('[data-viewport]');
          this.modal = this.querySelector('[data-modal]');
          this.pops = Array.from(this.querySelectorAll('[data-pop]'));
          this.popupEnabled = this.dataset.popup === 'true' && !!this.modal;
          this.active = 0;
          this.lastPointer = 'mouse';
          this.trigger = null;
          this.swipe = null;
          this.closeTimer = null;
          this.suppressClick = false;
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.editMode = this.dataset.drag === 'true' && !!(window.Shopify && window.Shopify.designMode);
          if (this.editMode) this.classList.add('hv--edit');

          this.spots.forEach((spot, i) => {
            const btn = spot.querySelector('[data-spot-btn]');
            const tip = spot.querySelector('[data-tip]');

            spot.addEventListener('pointerdown', (e) => (this.lastPointer = e.pointerType), true);

            // Hover: slide the product list to this hotspot's product
            spot.addEventListener('pointerenter', (e) => {
              if (e.pointerType === 'touch') return;
              this.activate(i);
              this.placeTip(spot);
            });

            btn.addEventListener('focus', () => {
              this.activate(i);
              this.placeTip(spot);
            });

            btn.addEventListener('click', () => {
              if (this.suppressClick) return;
              this.onSpotClick(i, spot, btn);
            });
            if (this.editMode) this.initDrag(spot, btn, i);
            if (tip) tip.addEventListener('click', () => this.openModal(i, btn));

            // Theme editor: select the hotspot block to preview it
            spot.addEventListener('shopify:block:select', () => {
              this.activate(i);
              this.showTip(i);
              this.placeTip(spot);
            });
            spot.addEventListener('shopify:block:deselect', () => this.showTip(-1));
          });

          this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.activate(i)));

          // Touch: tapping outside hides the tooltip
          this.onDocClick = (e) => {
            if (!e.target.closest('[data-spot]')) this.showTip(-1);
          };
          document.addEventListener('click', this.onDocClick);

          // Swipe the product slider on touch screens
          if (this.viewport) {
            this.viewport.addEventListener('pointerdown', (e) => {
              if (e.pointerType === 'mouse') return;
              this.swipe = { x: e.clientX, id: e.pointerId };
            });
            const end = (e) => {
              const s = this.swipe;
              this.swipe = null;
              if (!s || e.pointerId !== s.id) return;
              const dx = e.clientX - s.x;
              if (Math.abs(dx) < 40) return;
              this.activate(Math.max(0, Math.min(this.slides.length - 1, this.active + (dx < 0 ? 1 : -1))));
            };
            this.viewport.addEventListener('pointerup', end);
            this.viewport.addEventListener('pointercancel', () => (this.swipe = null));
          }

          if (this.popupEnabled) this.initModal();
          this.applyState();

          // Size the card from the height left in the image-height column so it never overflows it
          this.fitCard = () => {
            if (!this.viewport) return;
            if (!window.matchMedia('(min-width: 750px)').matches) {
              this.style.removeProperty('--hv-card-w');
              return;
            }
            // available height = the column (image height) minus the dots
            const inner = this.querySelector('.hv__side-inner');
            const dotsEl = this.querySelector('.hv__dots');
            const dotsH = dotsEl ? dotsEl.offsetHeight + 16 : 0;
            const h = (inner ? inner.clientHeight : this.viewport.clientHeight) - dotsH - 12;
            const w = this.viewport.clientWidth - 12;
            let cardW = Math.min(w, Math.max(200, h * 0.65));
            this.style.setProperty('--hv-card-w', Math.round(cardW) + 'px');

            // The card keeps its natural height: if the tallest card is taller than the column, narrow all cards until it fits
            for (let k = 0; k < 3; k++) {
              const tallest = Math.max(0, ...this.slides.map((s) => (s.firstElementChild ? s.firstElementChild.offsetHeight : 0)));
              if (!tallest || tallest <= h) break;
              cardW = Math.max(160, cardW * (h / tallest) * 0.98);
              this.style.setProperty('--hv-card-w', Math.round(cardW) + 'px');
            }
          };
          if (this.viewport && 'ResizeObserver' in window) {
            this.fitObserver = new ResizeObserver(() => this.fitCard());
            this.fitObserver.observe(this.querySelector('.hv__side-inner') || this.viewport);
          }
          window.addEventListener('resize', this.fitCard);
          this.fitCard();
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onDocClick);
          if (this.fitObserver) this.fitObserver.disconnect();
          if (this.fitCard) window.removeEventListener('resize', this.fitCard);
          if (this.unsubscribeCart) this.unsubscribeCart();
        }

        /* ---------- Hotspots + slider ---------- */

        activate(i) {
          if (i === this.active || i < 0 || i >= this.slides.length) return;
          this.active = i;
          this.applyState();
        }

        applyState() {
          if (this.track) this.track.style.setProperty('--i', this.active);
          this.spots.forEach((spot, i) => spot.classList.toggle('is-active', i === this.active));
          this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === this.active ? 'true' : 'false'));
          this.slides.forEach((slide, i) => {
            if (i === this.active) slide.removeAttribute('inert');
            else slide.setAttribute('inert', '');
          });
        }

        showTip(index) {
          this.spots.forEach((spot, i) => spot.classList.toggle('is-tip', i === index));
        }

        // Keep the tooltip inside the image and flip it above the hotspot if there is no room below
        placeTip(spot) {
          const tip = spot.querySelector('[data-tip]');
          if (!tip || !this.mediaEl) return;

          spot.classList.remove('is-flip');
          tip.style.setProperty('--tip-dx', '0px');

          const media = this.mediaEl.getBoundingClientRect();
          const rect = spot.getBoundingClientRect();
          const cx = rect.left + rect.width / 2;
          const tipW = tip.offsetWidth;
          const tipH = tip.offsetHeight;
          const pad = 8;

          let dx = 0;
          const left = cx - tipW / 2;
          const right = cx + tipW / 2;
          if (left < media.left + pad) dx = media.left + pad - left;
          else if (right > media.right - pad) dx = media.right - pad - right;
          tip.style.setProperty('--tip-dx', dx + 'px');

          if (rect.bottom + 12 + tipH > media.bottom - pad) spot.classList.add('is-flip');
        }

        onSpotClick(i, spot, btn) {
          const isTouch = this.lastPointer === 'touch' || window.matchMedia('(hover: none)').matches;

          // Touch: first tap previews (slides the product in + shows tooltip), second tap opens the popup
          if (isTouch && !spot.classList.contains('is-tip')) {
            this.activate(i);
            this.showTip(i);
            this.placeTip(spot);
            return;
          }

          if (this.popupEnabled) this.openModal(i, btn);
          else if (btn.dataset.url) window.location.href = btn.dataset.url;
        }

        /* ---------- Drag hotspots into place (theme editor) ---------- */

        initDrag(spot, btn, i) {
          let drag = null;

          btn.addEventListener('pointerdown', (e) => {
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            drag = { id: e.pointerId, x: e.clientX, y: e.clientY, moved: false };
          });

          btn.addEventListener('pointermove', (e) => {
            if (!drag || e.pointerId !== drag.id) return;

            if (!drag.moved) {
              if (Math.hypot(e.clientX - drag.x, e.clientY - drag.y) < 4) return;
              drag.moved = true;
              try {
                btn.setPointerCapture(drag.id);
              } catch (err) {}
              spot.classList.add('is-dragging');
              this.activate(i);
            }

            const rect = this.mediaEl.getBoundingClientRect();
            const px = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
            const py = Math.max(0, Math.min(100, ((e.clientY - rect.top) / rect.height) * 100));
            const x = Math.round(px);
            const y = Math.round(py);
            spot.style.setProperty('--x', x + '%');
            spot.style.setProperty('--y', y + '%');
            this.showCoords(i, x, y);
          });

          const end = (e) => {
            if (!drag || (e && e.pointerId !== drag.id)) return;
            const moved = drag.moved;
            drag = null;
            spot.classList.remove('is-dragging');
            try {
              btn.releasePointerCapture(e.pointerId);
            } catch (err) {}
            if (moved) {
              // swallow the click that follows a drag
              this.suppressClick = true;
              setTimeout(() => (this.suppressClick = false), 0);
              this.placeTip(spot);
            }
          };
          btn.addEventListener('pointerup', end);
          btn.addEventListener('pointercancel', end);
        }

        showCoords(i, x, y) {
          if (!this.coords) {
            this.coords = document.createElement('div');
            this.coords.className = 'hv__coords';
            this.coords.innerHTML =
              '<span data-coords-text></span><button type="button" data-coords-copy>Copy</button>';
            this.mediaEl.appendChild(this.coords);
            this.coords.querySelector('[data-coords-copy]').addEventListener('click', () => {
              const text = this.coords.dataset.value || '';
              if (navigator.clipboard) navigator.clipboard.writeText(text).catch(() => {});
            });
          }
          this.coords.hidden = false;
          this.coords.dataset.value = 'X: ' + x + ', Y: ' + y;
          this.coords.querySelector('[data-coords-text]').textContent =
            'Hotspot ' + (i + 1) + ' → Horizontal ' + x + '%, Vertical ' + y + '%  (enter these in the block settings to save)';
        }

        /* ---------- Popup ---------- */

        initModal() {
          const closeBtn = this.modal.querySelector('[data-close]');
          if (closeBtn) closeBtn.addEventListener('click', () => this.closeModal());

          // Click on the dimmed backdrop closes the popup
          this.modal.addEventListener('click', (e) => {
            if (e.target === this.modal) this.closeModal();
          });

          this.modal.addEventListener('close', () => {
            clearTimeout(this.closeTimer);
            this.modal.classList.remove('is-open');
            document.body.classList.remove('overflow-hidden');
            if (this.trigger && this.trigger.focus) this.trigger.focus();
          });

          // Escape: animate out instead of closing instantly
          this.modal.addEventListener('cancel', (e) => {
            e.preventDefault();
            this.closeModal();
          });

          // The cart drawer / notification sits below the top layer: close the popup once an item was added
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
              if (this.modal.open) this.closeModal();
            });
          }

          this.pops.forEach((pop) => this.initPop(pop));
        }

        openModal(i, trigger) {
          if (!this.popupEnabled) return;
          this.trigger = trigger || null;
          this.pops.forEach((pop, n) => (pop.hidden = n !== i));

          clearTimeout(this.closeTimer);

          const pop = this.pops[i];
          const gallery = pop && pop.querySelector('[data-gallery]');
          if (gallery) gallery.scrollTo({ left: 0, behavior: 'auto' });
          const scroller = pop && pop.querySelector('.hv-pop__scroll');
          if (scroller) scroller.scrollTop = 0;

          if (!this.modal.open) this.modal.showModal();
          document.body.classList.add('overflow-hidden');

          // two frames so the closed state is painted first and the open transition runs
          requestAnimationFrame(() =>
            requestAnimationFrame(() => {
              if (this.modal.open) this.modal.classList.add('is-open');
            })
          );
          this.activate(i);
        }

        closeModal() {
          if (!this.modal.open) return;
          this.modal.classList.remove('is-open');
          clearTimeout(this.closeTimer);
          this.closeTimer = setTimeout(
            () => {
              if (this.modal.open && !this.modal.classList.contains('is-open')) this.modal.close();
            },
            this.reduced ? 0 : 340
          );
        }

        initPop(pop) {
          const dataEl = pop.querySelector('[data-variants]');
          const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
          const form = pop.querySelector('form');
          const idInput = form ? form.querySelector('[name="id"]') : null;
          const addBtn = pop.querySelector('[type="submit"]');
          const addText = pop.querySelector('[data-add-text]');
          const buyBtn = pop.querySelector('[data-buy]');
          const groups = Array.from(pop.querySelectorAll('[data-option]'));
          const priceEl = pop.querySelector('[data-price]');
          const compareEl = pop.querySelector('[data-compare]');
          const offEl = pop.querySelector('[data-off]');
          const gallery = pop.querySelector('[data-gallery]');
          const gdots = Array.from(pop.querySelectorAll('[data-gdot]'));

          const t = {
            add: pop.dataset.tAdd,
            sold: pop.dataset.tSold,
            unavailable: pop.dataset.tUnavailable,
          };

          const setDisabled = (disabled) => {
            [addBtn, buyBtn].forEach((btn) => {
              if (!btn) return;
              btn.disabled = disabled;
              btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
            });
          };

          const findVariant = (values) => variants.find((v) => v.options.every((o, k) => o === values[k]));

          const scrollToMedia = (mediaId) => {
            if (!gallery || !mediaId) return;
            const slide = gallery.querySelector('[data-media-id="' + mediaId + '"]');
            if (slide) gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          };

          const update = (scrollMedia) => {
            const selected = groups.map((g) => {
              const checked = g.querySelector('input:checked');
              return checked ? checked.value : null;
            });

            // Labels + unavailable (sold out / missing) values for the other selections
            groups.forEach((g, i) => {
              const label = g.querySelector('[data-selected]');
              if (label) label.textContent = selected[i];
              g.querySelectorAll('input').forEach((input) => {
                const test = selected.slice();
                test[i] = input.value;
                const match = findVariant(test);
                input.closest('label').classList.toggle('is-unavailable', !(match && match.available));
              });
            });

            const variant = groups.length ? findVariant(selected) : variants[0];

            if (!variant) {
              setDisabled(true);
              if (addText) addText.textContent = t.unavailable;
              return;
            }

            if (idInput) idInput.value = variant.id;
            if (priceEl) priceEl.innerHTML = variant.price;
            if (compareEl) {
              compareEl.hidden = !variant.compare;
              if (variant.compare) compareEl.innerHTML = 'MRP ' + variant.compare;
            }
            if (offEl) {
              offEl.hidden = !(variant.off > 0);
              if (variant.off > 0) offEl.textContent = variant.off + '% OFF';
            }

            setDisabled(!variant.available);
            if (addText) addText.textContent = variant.available ? t.add : t.sold;
            if (scrollMedia) scrollToMedia(variant.media);
          };

          groups.forEach((g) => g.addEventListener('change', () => update(true)));
          update(false);

          // Gallery dots
          if (gallery && gdots.length) {
            gallery.addEventListener(
              'scroll',
              () => {
                const idx = Math.round(gallery.scrollLeft / (gallery.clientWidth || 1));
                gdots.forEach((d, n) => d.setAttribute('aria-current', n === idx ? 'true' : 'false'));
              },
              { passive: true }
            );
            gdots.forEach((d, n) =>
              d.addEventListener('click', () => gallery.scrollTo({ left: n * gallery.clientWidth, behavior: 'smooth' }))
            );
          }

          // Buy now: add the selected variant, then go straight to checkout
          if (buyBtn && idInput) {
            buyBtn.addEventListener('click', async () => {
              if (buyBtn.getAttribute('aria-disabled') === 'true') return;
              buyBtn.setAttribute('aria-disabled', 'true');
              const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
              try {
                const res = await fetch(root + 'cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify({ id: Number(idInput.value), quantity: 1 }),
                });
                if (!res.ok) throw new Error('add failed');
                window.location.href = root + 'checkout';
              } catch (err) {
                buyBtn.setAttribute('aria-disabled', 'false');
                const wrapper = pop.querySelector('.product-form__error-message-wrapper');
                const message = pop.querySelector('.product-form__error-message');
                if (wrapper && message) {
                  message.textContent = t.unavailable;
                  wrapper.hidden = false;
                }
              }
            });
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
